module.exports = __webpack_public_path__ + "img/stat_map_ru_mobile.7b793935.png";